import { useAuthStore } from '@stores/auth.context/auth.context'
import { Navigate, Outlet } from 'react-router-dom'

type Props = {
  redirect?: string
}

export const PrivateRoute: React.FC<Props> = ({ redirect = '/entrar' }) => {
  const { accessToken } = useAuthStore()
  const GetAccessToken = localStorage.getItem('access_token')
  return accessToken || GetAccessToken ? <Outlet /> : <Navigate to={redirect} />
}
